// extracted by mini-css-extract-plugin
export var loadingSpinner = "_1i-0";
export var spinnerContainer = "_1i-1";